import { EventGroup } from '@qodana/tracking'

import { CloudTrackingContext } from '../context'

/**
 * https://youtrack.jetbrains.com/issue/FUS-1701/Add-new-group-cloud-authorization
 */
export const AuthorizationEventGroup = new (class extends EventGroup<CloudTrackingContext, {}> {
	groupId = 'cloud.authorization' as const
	groupVersion = 2 as const

	events = {
		start: this.addEvent('start'),
		logout: this.addEvent('logout'),
		deleteAccount: this.addEvent('deleteAccount'), // https://youtrack.jetbrains.com/issue/FUS-1998/Update-group-cloudauthorization
	}
})()
